import React from "react";

import { BrasaoAraucaria, WebgeoLogo } from "../../../../shared/assets/logos";

import environments from "../../../../environments";

import { Container } from "./styles";
import { Divisor } from "../../bci/styles";

interface HeaderProps {
    subscription: string;
}

export const AraucariaHeader: React.FC<HeaderProps> = ({ subscription }) => {
    return (
        <>
            <Container>
                <div style={{ flex: 1 }}>
                    <div style={{ width: "150px", marginLeft: "5px" }}>
                        <img src={BrasaoAraucaria} alt="logo cidade" />
                    </div>
                </div>
                <div style={{ flex: 1 }}>
                    <div
                        style={{
                            marginLeft: "10px",
                            fontSize: "18pt",
                            fontWeight: "bold",
                            color: "gray",
                        }}
                    >
                        <p>{environments.webgeo.bci?.nomeSecretaria}</p>
                    </div>
                </div>
                <div style={{ flex: 1 }}>
                    <div>
                        <p>
                            Inscrição Imobiliária: <br />
                            {subscription}
                        </p>
                        <p>
                            DATA:{" "}
                            {new Date(Date.now()).toLocaleDateString("pt-BR")}{" "}
                        </p>
                    </div>
                </div>
                <div style={{ flex: 1 }}>
                    <section>
                        <img src={WebgeoLogo} alt="logo webgeo" />
                    </section>
                </div>
            </Container>
            <Divisor />
        </>
    );
};
